export default __webpack_public_path__ + "static/media/erik-lucatero-2.e4098b40.jpg";